import axios from "axios"

export async function fetchNotificationLogs(query = '') {
    return await axios.get(`notifications/notification-log?${query}`)
        .then(res => {
            return res.data
        })
        .catch(e => {
            throw e
        })
}

export async function retryNotification(id) {
    return await axios.post(`notifications/notification-log/${id}/retry/`)
        .then(res => {
            return res.data
        })
        .catch(e => {
            throw e
        })
}
